/**
 * Katakana -> galmoji.
 *
 * Ported verbatim from galjp v4 (lib/chars/katakana.json). The values are intentionally
 * unchanged — see docs/DESIGN.md premise 3. Regenerate with:
 *   npm run data:port
 */
export const katakana: Readonly<Record<string, string>> = {
  ア: '了',
  イ: 'ィ',
  ウ: '宀',
  エ: 'ヱ',
  オ: '才',
  カ: 'ヵ',
  キ: '≠',
  ク: '勹',
  ケ: 'ヶ',
  コ: '⊃',
  サ: '廾',
  シ: '=ﾉ',
  ス: 'ス',
  セ: '七',
  ソ: '｀ﾉ',
  タ: '勺',
  チ: '千',
  ツ: '〃ﾉ',
  テ: '〒',
  ト: '├',
  ナ: '＋',
  ニ: '＝',
  ヌ: '又',
  ネ: '衤',
  ノ: '丿',
  ハ: '/ヽ',
  ヒ: '匕',
  フ: '┐',
  ヘ: '∧',
  ホ: '木',
  マ: 'ма',
  ミ: '彡',
  ム: '厶',
  メ: '乂',
  モ: 'м○',
  ヤ: '兯',
  ユ: 'ュ',
  ヨ: '∋',
  ラ: 'ラ',
  リ: 'ױ',
  ル: '儿',
  レ: 'Ｖ',
  ロ: '□',
  ワ: 'ヮ',
  ヲ: 'ヲ',
  ン: '冫',
  ヴ: '宀”',
  ガ: 'ヵ”',
  ギ: '≠”',
  グ: '勹”',
  ゲ: 'ヶ”',
  ゴ: '⊃”',
  ザ: '廾”',
  ジ: '=ﾉ”',
  ズ: 'ス”',
  ゼ: '七”',
  ゾ: '｀ﾉ”',
  ダ: '勺”',
  ヂ: '千”',
  ヅ: '〃ﾉ”',
  デ: '〒”',
  ド: '├”',
  バ: '/ヽ”',
  ビ: '匕”',
  ブ: '┐”',
  ベ: '∧”',
  ボ: '木”',
  パ: '/ヽo',
  ピ: '匕o',
  プ: '┐o',
  ペ: '∧o',
  ポ: '木o',
  ァ: '了',
  ィ: 'ィ',
  ゥ: '宀',
  ェ: 'ヱ',
  ォ: '才',
  ッ: '〃ﾉ',
  ャ: '兯',
  ュ: 'ュ',
  ョ: '∋',
  ヮ: 'ヮ',
  ー: '→',
};
